<template>
  <div>
    <v-row>
      <v-col>
        <v-text-field
            hide-details
            :style="`font-size: 14px;`"
            color="primary"
            label="Label"
            type="text"
            :class="[getDirtyClass(item, 'label'), isLocked ? 'disable-events' : '']"
            @update:model-value="setNestedParameter({value: $event, item: item, parameter: 'label'});  addDirty(item, 'label')"
            :model-value="item.label"></v-text-field>
      </v-col>

      <v-col>
        <v-text-field
            hide-details
            :style="`font-size: 14px;`"
            color="primary"
            label="Wind force"
            type="number"
            :class="[getDirtyClass(item, 'wind_force'), isLocked ? 'disable-events' : '']"
            @update:model-value="setNestedParameter({value: $event, item: item, parameter: 'wind_force'});  addDirty(item, 'wind_force')"
            :model-value="item.wind_force"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
            hide-details
            :style="`font-size: 14px;`"
            color="primary"
            label="Top of tree [x]"
            type="number"
            :class="[getDirtyClass(item, 'top_of_tree_x'), isLocked ? 'disable-events' : '']"
            @update:model-value="setNestedParameter({value: $event, item: item, parameter: 'top_of_tree_x'});  addDirty(item, 'top_of_tree_x')"
            :model-value="item.top_of_tree_x"></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
            hide-details
            :style="`font-size: 14px;`"
            color="primary"
            label="Top of tree [z]"
            type="number"
            :class="[getDirtyClass(item, 'top_of_tree_z'), isLocked ? 'disable-events' : '']"
            @update:model-value="setNestedParameter({value: $event, item: item, parameter: 'top_of_tree_z'});  addDirty(item, 'top_of_tree_z')"
            :model-value="item.top_of_tree_z"></v-text-field>
      </v-col>

    </v-row>
    <v-row>
      <v-col>
        <v-text-field
            hide-details
            :style="`font-size: 14px;`"
            color="primary"
            label="Width root zone"
            type="number"
            :class="[getDirtyClass(item, 'width_root_zone'), isLocked ? 'disable-events' : '']"
            @update:model-value="setNestedParameter({value: $event, item: item, parameter: 'width_root_zone'});  addDirty(item, 'width_root_zone')"
            :model-value="item.width_root_zone"></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
            hide-details
            class="mb-3"
            :style="`font-size: 14px;`"
            color="primary"
            label="Spread"
            step="15"
            type="number"
            :class="[getDirtyClass(item, 'spread'), isLocked ? 'disable-events' : '']"
            @update:model-value="setNestedParameter({value: $event, item: item, parameter: 'spread'});  addDirty(item, 'spread')"
            :model-value="item.spread"></v-text-field>

      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
            hide-details
            :style="`font-size: 14px;`"
            color="primary"
            :class="[getDirtyClass(item, 'drained_material'), isLocked ? 'disable-events' : '']"
            label="Drained consolidation [%]"
            type="number"
            @update:model-value="setNestedParameter({value: $event, item: item, parameter: 'drained_consolidation'});  addDirty(item, 'drained_consolidation')"
            :model-value="item.drained_consolidation"></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
            hide-details
            class="mb-3"
            :style="`font-size: 14px;`"
            color="primary"
            :class="[getDirtyClass(item, 'undrained_consolidation'), isLocked ? 'disable-events' : '']"
            step="15"
            label="Undrained consolidation [%]"
            type="number"
            @update:model-value="setNestedParameter({value: $event, item: item, parameter: 'undrained_consolidation'});  addDirty(item, 'undrained_consolidation')"
            :model-value="item.undrained_consolidation"></v-text-field>
      </v-col>
    </v-row>



  </div>
</template>
<script>
import {mapActions, mapGetters, mapState} from "vuex";
import DirtyFieldsStateMixIn from '@/mixins/DirtyFieldsStateMixIn.vue';

export default {
  name: 'TreeLoad',
  mixins: [DirtyFieldsStateMixIn],
  props: {item: {required: true}},
  data: () => ({
    storeName: 'treeLoads'
  }),
  computed: {
    ...mapState('treeLoads', {
      currentItem: state => state.currentItem,
      loading: state => state.loading,
    }),
    ...mapGetters('stabSchematisation', {
      isLocked: "isLockedCurrent",
    }),
  },
  methods: {
    ...mapActions('treeLoads', {
          setNestedParameter: "setNestedParameter",
        },
    ),
    close() {
      this.$refs.form.resetValidation()
    },

  },
  mounted() {
  }
}
</script>
